"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetViewsGroupTypes = void 0;
var data_store_1 = __importDefault(require("../data-store"));
var storable_data_service_1 = __importDefault(require("../storable-data-service"));
var preset_views_service_1 = require("./preset-views-service");
var PresetViewsGroupTypes;
(function (PresetViewsGroupTypes) {
    PresetViewsGroupTypes["View"] = "view";
})(PresetViewsGroupTypes = exports.PresetViewsGroupTypes || (exports.PresetViewsGroupTypes = {}));
var PresetViewsApi = /** @class */ (function () {
    function PresetViewsApi(session) {
        var _this = this;
        this.get = function (id) {
            return _this.presetViewsStore.get(id);
        };
        this.getAll = function () {
            return _this.presetViewsStore.getAll();
        };
        this.loadAll = function () {
            return _this.storableDataService.loadAll('loadAll', function () { return _this.presetViewsService.loadAll(); });
        };
        this.create = function (presetView) {
            return _this.storableDataService.modify('create', function () { return _this.presetViewsService.create(presetView); });
        };
        this.patch = function (presetView) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storableDataService.modify('patch', function () { return _this.presetViewsService.patch(presetView); })];
                    case 1:
                        result = _a.sent();
                        this.presetViewsStore.set(result);
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.delete = function (id) {
            return _this.storableDataService.delete('delete', function () { return _this.presetViewsService.delete(id); }, id);
        };
        // todo: investigate how to make store items true shallow
        this.presetViewsStore = new data_store_1.default([
            {
                groupType: PresetViewsGroupTypes.View,
                keyFunc: function (userPresetView) { return userPresetView.view; }
            }
        ]);
        this.presetViewsService = new preset_views_service_1.PresetViewsService(session);
        this.storableDataService = new storable_data_service_1.default(this.presetViewsStore);
    }
    PresetViewsApi.prototype.getGroupByGroupKey = function (groupKey, searchKey) {
        return this.presetViewsStore.getGroup(groupKey, searchKey);
    };
    return PresetViewsApi;
}());
exports.default = PresetViewsApi;
//# sourceMappingURL=preset-views-api.js.map